module.exports = __webpack_public_path__ + "html/salma-webinars_8cd9637562482636f7fe8d06388dd5d8.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave/salma-webinars.html
// module id = EStm
// module chunks = 35